"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.takeLast = void 0;
var safe_slice_1 = require("./safe-slice");
/** @internal */
var takeLast = function (array, num) {
    return (0, safe_slice_1.safeSlice)(array, array.length - num, array.length);
};
exports.takeLast = takeLast;
